import { render, staticRenderFns } from "./About the Group.vue?vue&type=template&id=274b6fb3&scoped=true&"
import script from "./About the Group.vue?vue&type=script&lang=js&"
export * from "./About the Group.vue?vue&type=script&lang=js&"
import style0 from "./About the Group.vue?vue&type=style&index=0&id=274b6fb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b6fb3",
  null
  
)

export default component.exports